const themeTypography = {
  fontFamily: "SF, sans-serif",
  htmlFontSize: 16,
  fontSize: 16,
  fontWeight: 400,
  caption: {
    fontSize: "0.8rem",
    fontWeight: 400,
  },
  body2: {
    fontSize: "0.95rem",
    fontWeight: 400,
  },
  body1: {
    fontSize: "1.15rem",
    fontWeight: 400,
    lineHeight: 1.2,
  },
  h6: {
    fontSize: "1.25rem",
    fontWeight: 400,
    lineHeight: 1.2,
  },
  h5: {
    fontSize: "1.35rem",
    fontWeight: 400,
    lineHeight: 1.2,
  },
  h4: {
    fontSize: "1.75rem",
    fontWeight: 500,
    lineHeight: 1.2,
  },
  h3: {
    fontSize: "2.2rem",
    fontWeight: 500,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: "3rem",
    fontWeight: 500,
    lineHeight: 1.2,
  },
  h1: {
    fontSize: "4rem",
    fontWeight: 700,
    lineHeight: 1.2,
  },
  button: {
    textTransform: "none",
  },
};

export default themeTypography;
